import { render, staticRenderFns } from "./System.List.vue?vue&type=template&id=59f0ef46&"
import script from "./System.List.vue?vue&type=script&lang=js&"
export * from "./System.List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports